import { DashboardModule, Form } from '@domain-group/suit-theme'

import type { UseBrandFormPayload } from '@hooks/useBrand'

import ToggleListItem from '@components/ToggleListItem'

import { toggleNestedValue } from '@functions/entity'

interface FeaturesProps {
  brandFormPayload: UseBrandFormPayload,
}

const Features = (props: FeaturesProps) => {
  const { brandFormPayload } = props

  const {
    entityState: {
      options,
    },
  } = brandFormPayload

  const {
    artwork_builder_template_requests_enabled,
    cross_agency_collaboration,
    require_template_specialists,
    template_designer,
  } = options

  return (
    <DashboardModule title="Features">
      <Form padding="large" boxProps={{ paddingBottom: 'medium' }}>
        <ToggleListItem
          onClick={() => (
            toggleNestedValue(brandFormPayload, 'options.cross_agency_collaboration', { shouldSetState: true })
          )}
          toggleValue={!!cross_agency_collaboration}
          toggleOffText="No"
          toggleOnText="Yes"
        >
          <ToggleListItem.Title>Cross Agency Collaboration</ToggleListItem.Title>

          <ToggleListItem.Description>
            Agencies can assign campaigns to agencies linked by brand
          </ToggleListItem.Description>
        </ToggleListItem>

        <ToggleListItem
          onClick={() => toggleNestedValue(brandFormPayload, 'options.template_designer', { shouldSetState: true })}
          toggleValue={!!template_designer}
          toggleOffText="No"
          toggleOnText="Yes"
        >
          <ToggleListItem.Title>Brand Template Management</ToggleListItem.Title>

          <ToggleListItem.Description>
            Brand can access and control template access with Brand Admin
          </ToggleListItem.Description>
        </ToggleListItem>

        <ToggleListItem
          onClick={() => toggleNestedValue(
            brandFormPayload,
            'options.require_template_specialists',
            { shouldSetState: true },
          )}
          toggleValue={!!require_template_specialists}
          toggleOffText="No"
          toggleOnText="Yes"
        >
          <ToggleListItem.Title>Template Specialists</ToggleListItem.Title>

          <ToggleListItem.Description>
            Brand uses specific templatye specialists
          </ToggleListItem.Description>
        </ToggleListItem>

        <ToggleListItem
          onClick={() => toggleNestedValue(
            brandFormPayload,
            'options.artwork_builder_template_requests_enabled',
            { shouldSetState: true },
          )}
          toggleValue={!!artwork_builder_template_requests_enabled}
          toggleOffText="No"
          toggleOnText="Yes"
        >
          <ToggleListItem.Title>Artwork Builder Template Requests</ToggleListItem.Title>

          <ToggleListItem.Description>
            Agencies can access &apos;Request Change or Fix&apos; button within the Artwork Builder
          </ToggleListItem.Description>
        </ToggleListItem>
      </Form>
    </DashboardModule>
  )
}

export default Features
